import React, { useEffect, useState } from 'react';
import { useRafTimeout } from 'ahooks';
import { getUser } from '@/api';

export function useNickName({ yxUid, defaultName }: { yxUid?: string; defaultName: string }) {
  const [resultNme, setName] = useState('');

  const clearTimeOut = useRafTimeout(() => {
    if (!resultNme) {
      setName(defaultName);
    }
  }, 1000);

  useEffect(() => {
    if (!yxUid) {
      setName(defaultName);
      clearTimeOut();
      return;
    }
    getUser(yxUid, true).then((n: defs.api.ParticipantsInformationV3) => {
      setName(n.memberName || '');
      clearTimeOut();
    });
  }, [defaultName]);

  return resultNme;
}

const NickName: ({ yxUid, defaultName }: { yxUid: any; defaultName: any }) => string = ({
  yxUid,
  defaultName,
}) => {
  const name = useNickName({ yxUid, defaultName });

  return name;
};

export default NickName;
